import { MoreHorizontalIcon } from "lucide-react";
import { AvatarTooltip } from "./AvatarTooltip";

export default function AvatarButton({ icon = <MoreHorizontalIcon />, title, className = "", ...props }: any) {
  return (
    <AvatarTooltip content={title}>
      <button type="button" className={["pyne-avatar-btn", className].join(" ")} aria-label={title} {...props}>
        {icon}
      </button>
    </AvatarTooltip>
  );
}
